import React from 'react';
import {useTranslation} from 'react-i18next';
import Button from 'components/Button';
import i18n from 'i18n';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Dialog from 'components/Dialog';
import {DialogTypes, DialogResult} from 'common/names';
import {Grid} from '@mui/material';

type DialogProps = {
   suspend: () => void;
   doNotSuspend: () => void;
   cancel: () => void;
};

const AuditWarningForm = ({suspend, doNotSuspend, cancel}: DialogProps) => {
   const {t} = useTranslation();
   return (
      <div>
         <Typography gutterBottom>
            {t(
               'Changing the Audit DB Settings while jobs are executing is potentially unsafe (e.g., audit records can be written without having their email and paging statuses set correctly).'
            )}
         </Typography>
         <Box textAlign={'center'}>
            <Typography>
               {t("Click 'Suspend' to suspend all jobs before updating the settings.")}
            </Typography>
            <Typography>
               {t("Click 'Continue' to continue without suspending all jobs.")}
            </Typography>
            <Typography>
               {t("Click 'Cancel' to return to the Audit DB Settings dialog.")}
            </Typography>
         </Box>
         <Grid container spacing={2} justifyContent="center">
            <Grid item>
               <Button type="submit" onClick={suspend}>
                  {i18n.t('Suspend')}
               </Button>
            </Grid>
            <Grid item>
               <Button type="submit" onClick={doNotSuspend}>
                  {i18n.t('Continue')}
               </Button>
            </Grid>
            <Grid item>
               <Button type="button" onClick={cancel}>
                  {i18n.t('Cancel')}
               </Button>
            </Grid>
         </Grid>
      </div>
   );
};

type Props = {
   onClose: (result?: string) => void;
};
export const AuditWarningDialog = ({onClose}: Props) => {
   return (
      <Dialog maxWidth="lg" header={DialogTypes.AuditWarningDialog.dialogName} close={onClose}>
         <AuditWarningForm
            suspend={() => onClose(DialogResult.AUDIT_SUSPEND)}
            doNotSuspend={() => onClose(DialogResult.AUDIT_DONT_SUSPEND)}
            cancel={onClose}
         />
      </Dialog>
   );
};

export default AuditWarningDialog;
